/**
* @file 运营中心-平台审核-司机审核
* */
<template>
  <div id="driverAudit">
    <custom-table :has-channel="true" ref="customTable" has-organization="true" :customOptions="customOptions"
      :columns="columns">
      <template slot="customTable-top">
        <el-radio-group v-model="status" @change="statusChange" style="padding-bottom: 16px;">
          <el-radio-button :label="item.value" v-for="item in $const.DRIVERAUDITSTATUS.filter(item => item.value != 3)" :key="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </template>

      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="128px">
          <div slot-scope="{row}" class="custom-action">
            <el-button v-if="row.applyStatus > 2" type="text" @click="viewClick(row, 'detail')">详情</el-button>
            <el-button v-if="row.applyStatus === 2" type="text" @click="viewClick(row, 'audit')">审核</el-button>
            <el-button v-if="row.applyStatus === 1" style="color: #F00;" class="util-danger" type="text"
              @click="removeClick(row.id)">删除</el-button>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'phone'">
          <span>{{ row.phone }}</span>
        </template>
        <template v-else-if="item.prop === 'applyStatus'">
          <el-tag v-for="s in $const.DRIVERAUDITSTATUS.filter(s => s.value == row.applyStatus)"
            :key="s.value" :type="s.type" size="small">{{ s.label }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'auditAdminName'">
          <span v-if="row.auditAdminName" style="font-weight:500">{{ row.auditAdminName }}</span>
          <span v-else style="color:#c0c4cc">-</span>
        </template>
        <template v-else-if="['created', 'auditTime', 'applyTime'].includes(item.prop)">
          <span style="white-space:nowrap">{{ row[item.prop] | filterTime }}</span>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : '-' }}</span>
        </template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "driverAudit",
  data() {
    return {
      // 司机审核状态
      status: 2,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/driver/audit',
        params: {
          applyStatus: 2,
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          { type: 'input', field: 'name', name: '司机名称', value: '' },
          { type: 'input', field: 'phone', name: '手机号码', value: '' },
          { type: 'input', field: 'idCard', name: '身份证号', value: '' }
        ]
      },
      // 表头
      columns: [
        { prop: 'phone', label: '手机号码', minWidth: 130 },
        { prop: 'name', label: '司机姓名', minWidth: 90 },
        { prop: 'idCard', label: '身份证号码', minWidth: 160 },
        { prop: 'applyStatus', label: '审核状态', minWidth: 90 },
        { prop: 'auditAdminName', label: '审核人', minWidth: 90 },
        { prop: 'created', label: '注册时间', minWidth: 150 },
        { prop: 'applyTime', label: '认证时间', minWidth: 150 },
        { prop: 'auditTime', label: '审核时间', minWidth: 150 },
      ],
    }
  },
  created() {
    if (this.$route.query.status) {
      this.status = this.$route.query.status
      this.customOptions.params.applyStatus = this.status
    }
  },
  methods: {
    /**
     * 状态改变
     */
    statusChange() {
      if (this.status != 4) {
        this.columns = this.columns.filter(item => item.prop != 'refusalReason')
        this.customOptions.params.page = 1
        this.customOptions.params.applyStatus = this.status;
        this.$refs.customTable.listFn();
      } else {
        this.columns.push({ prop: 'refusalReason', label: '拒绝原因', minWidth: 320 })
        this.customOptions.params.page = 1
        this.customOptions.params.applyStatus = this.status;
        this.$nextTick(() => {
          this.$refs.customTable.listFn()
        })
      }
    },
    viewClick(row, type) {
      this.$router.push({
        path: 'driverAuditDetail',
        query: {
          id: row.id,
          type: type
        }
      })
    },
    /**
     * 列表-删除
     */
    async removeClick(id) {
      let url = '/api/v1/manage/driver/audit';
      let { code } = await this.$axios.delete(url, {
        id: id
      });
      if (code === 1) {
        this.$message.success('删除成功');
        this.$refs.customTable.listFn()
      }else {
        this.$refs.customTable.listFn()
      }
    },
  }
}
</script>